import React from "react";
import Rooms from "./roomsWrapper/Rooms";

export default function RoomsWrapper({rooms, REMOVE_ROOM, GET_ROOMS}){
    
    let props = {
        rooms, 
        GET_ROOMS,
        REMOVE_ROOM,
    };

    return <Rooms props={props}/>
}


// WEBPACK FOOTER //
// ./src/components/general/RoomsWrapper.jsx